export const navItems = [
    { path: '/', title: 'Inicio' },
    { path: '/about-us', title: '¿Quiénes somos?' },
    { path: '/frequent-questions', title: 'Preguntas frecuentes' },
    { path: '/contact', title: 'Contacto' },
]

export type navbar = 'full' | 'support' | 'init' | 'default'
